import HeartEbookSolid from '@assets/icons/heart-ebook-solid.svg'
import { Icon } from './Icon'

export const HeartEbookSolidIcon = Icon(HeartEbookSolid)
